import { render, staticRenderFns } from "./FlowShell.vue?vue&type=template&id=2a42275c"
import script from "./FlowShell.vue?vue&type=script&lang=ts"
export * from "./FlowShell.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports